import { defineStore } from 'pinia';

// Need to rethink this store.
export const useWindowStore = defineStore('window', {
    state: () => {
        return {
            scrollY: 0,
            innerWidth: 1920,
            innerHeight: 1080,
            breakpointMobile: 768,
            breakpointTablet: 1024,
            breakpointDesktop: 1290,
            deviceIs: 'mobile',
            browserIs: 'chrome',
            vh: 10.8,
            scrolling: 'down'
        };
    },
    actions: {
        updateScrollY(y) {
            this.scrolling = (this.scrollY > y) ? 'down' : 'up';
            this.scrollY = y;
        },
        updateHeight(h) {
            this.innerHeight = h;
            this.vh = h / 100;
        },
        updateWidth(w) {
            this.innerWidth = w;
        },
        updateDeviceIs() {
            if (this.innerWidth <= this.breakpointMobile) {
                this.deviceIs = 'mobile';
            } else if (this.innerWidth <= this.breakpointTablet) {
                this.deviceIs = 'tablet';
            } else if (this.innerWidth <= this.breakpointDesktop) {
                this.deviceIs = 'desktop';
            } else {
                this.deviceIs = 'desktop';
            }
        },
        updateBrowserIs() {
            const ua = navigator.userAgent.toLowerCase();
            const isIphone = ua.indexOf('iphone') > -1;
            const isIpad = ua.indexOf('ipad') > -1;
            const hasApple = ua.indexOf('apple') > -1;

            const hasChrome = ua.indexOf('chrome') > -1;
            const hasGecko = ua.indexOf('gecko') > -1;

            const skip = isIphone || isIpad || hasApple;
            const chrome = hasChrome || hasGecko;

            if (skip || !chrome) this.browserIs = 'safari';

            if (!skip && chrome) this.browserIs = 'chrome';

            if (ua.indexOf('firefox') !== -1) this.browserIs = 'firefox';

            if (!skip && !chrome && !ua.indexOf('firefox') !== -1) this.browserIs = 'unknown';
        },
    },
});
